<template>
  <div id="app" class="flex h-full flex-col">
    <!-- 导航栏 -->
    <Nav />
    <!-- 路由内容 -->
    <div class="content">
      <router-view />
    </div>
    <!-- 页脚 -->
    <Footer />
    <!-- 弹窗 -->
    <DialogContainer />
  </div>
</template>

<script>
import Nav from '@/components/Nav.vue';
import Footer from '@/components/Footer.vue';
import DialogContainer from '@/dialogs/DialogContainer.vue';

export default {
  name: 'App',
  components: {
    Nav,
    Footer,
    DialogContainer,
  },
  mounted(){
    // 初始化vuex数据
    this.$store.dispatch('initialData');
  }
};
</script>

<style lang="scss"></style>
